import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { cloneDeep } from 'lodash';
import { HISCOX_BOP_DECLARATION, HISCOX_CYBER_DECLARATION, HISCOX_PI_DECLARATION, HISCOX_PL_DECLARATION, greatAmericanBusinessInsuranceClassServiceAdvertisingAgenciesKey, greatAmericanBusinessInsuranceClassServiceConsultantGeneralKey, greatAmericanBusinessInsuranceClassServiceConsultantManagementRiskManagementKey, greatAmericanBusinessInsuranceClassServiceGraphicArtistDesignKey, hiscoxClassServiceArchitectureKey, hiscoxClassServiceBrandConsultantKey, hiscoxClassServiceEducationConsultingKey, hiscoxClassServiceITConsultingKey, hiscoxClassServiceLandscapeArchitectKey, hiscoxClassServiceRecruitingEmploymentPlacementsKey, hiscoxClassServiceSoftwareDevelopmentsKey } from '../../constants';
import { BUSINESS_OWNERS_POLICY_COVER, CYBER_LIABILITY_COVER, PROFESSIONAL_INDEMNITY, PUBLIC_LIABILITY } from '../../constants/coverage';
import { HISCOX_DECLARATION, getAllQuoteQuestionInfoMap } from '../../localeConstants';
export var useHiscoxDeclaration = function useHiscoxDeclaration() {
  // Declarations
  var generatePhysicalServices1 = function generatePhysicalServices1(list, config) {
    var _config$covers, _config$covers2, _config$covers3;

    if ((!!(config !== null && config !== void 0 && (_config$covers = config.covers) !== null && _config$covers !== void 0 && _config$covers[PROFESSIONAL_INDEMNITY]) || !!(config !== null && config !== void 0 && (_config$covers2 = config.covers) !== null && _config$covers2 !== void 0 && _config$covers2[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers3 = config.covers) !== null && _config$covers3 !== void 0 && _config$covers3[BUSINESS_OWNERS_POLICY_COVER])) && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Physical Services',
        list: [{
          hideDot: true,
          text: 'Your business (or any of your subcontractors) DOES NOT directly perform an of the following physical services:',
          list: [{
            text: 'Carpentry',
            showDot: true
          }, {
            text: 'Construction, demolition, or remodeling',
            showDot: true
          }, {
            text: 'Delivery',
            showDot: true
          }, {
            text: 'Electrical',
            showDot: true
          }, {
            text: 'Equipment installation or repair',
            showDot: true
          }, {
            text: 'Flooring',
            showDot: true
          }, {
            text: 'General contracting',
            showDot: true
          }, {
            text: 'Home building',
            showDot: true
          }, {
            text: 'Lawn or garden maintenance',
            showDot: true
          }, {
            text: 'Painting',
            showDot: true
          }, {
            text: 'Plumbing',
            showDot: true
          }, {
            text: 'Roofing',
            showDot: true
          }, {
            text: 'Tiling',
            showDot: true
          }, {
            text: 'Transportation',
            showDot: true
          }, {
            text: 'Any other physical maintenance/repair services',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateServices1 = function generateServices1(list, config) {
    var _config$covers4, _config$covers5, _config$covers6;

    if ((!!(config !== null && config !== void 0 && (_config$covers4 = config.covers) !== null && _config$covers4 !== void 0 && _config$covers4[PROFESSIONAL_INDEMNITY]) || !!(config !== null && config !== void 0 && (_config$covers5 = config.covers) !== null && _config$covers5 !== void 0 && _config$covers5[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers6 = config.covers) !== null && _config$covers6 !== void 0 && _config$covers6[BUSINESS_OWNERS_POLICY_COVER])) && [hiscoxClassServiceArchitectureKey, hiscoxClassServiceLandscapeArchitectKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business (or any of your subcontractors) DOES NOT provide any of the following services or work on any projects involving the following materials or infrastructure:',
          list: [{
            text: 'Aerospace engineering',
            showDot: true
          }, {
            text: 'Amusement rides, pools or playgrounds',
            showDot: true
          }, {
            text: 'Asbestos, lead, or mold evaluation or abatement',
            showDot: true
          }, {
            text: 'Bridges, dams, harbors, mines, piers or tunnels',
            showDot: true
          }, {
            text: 'Building Envelope Inspections',
            showDot: true
          }, {
            text: 'Condominiums',
            showDot: true
          }, {
            text: 'Design/build firms',
            showDot: true
          }, {
            text: 'Emergency response or clean-up of any hazardous waste',
            showDot: true
          }, {
            text: 'Foundation, sheeting or retaining wall design',
            showDot: true
          }, {
            text: 'Geotechnical / soils engineering',
            showDot: true
          }, {
            text: 'Home inspections for prospective buyers or lenders, or to be used in a real estate transaction',
            showDot: true
          }, {
            text: 'Hydraulic fracturing, hydrofracturing, or fracking',
            showDot: true
          }, {
            text: 'Laboratory testing',
            showDot: true
          }, {
            text: 'Land acquisition',
            showDot: true
          }, {
            text: 'Land surveying, boundary surveying or construction staking',
            showDot: true
          }, {
            text: 'Marine engineering',
            showDot: true
          }, {
            text: 'Mechanical engineering',
            showDot: true
          }, {
            text: 'Mining engineering',
            showDot: true
          }, {
            text: 'Nuclear engineering',
            showDot: true
          }, {
            text: 'Oil, gas or well engineering',
            showDot: true
          }, {
            text: 'Petro / chemical engineering',
            showDot: true
          }, {
            text: 'Structural engineering',
            showDot: true
          }, {
            text: 'Underground storage tanks or utilities',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateServices2 = function generateServices2(list, config) {
    var _config$covers7;

    if (!!(config !== null && config !== void 0 && (_config$covers7 = config.covers) !== null && _config$covers7 !== void 0 && _config$covers7[PROFESSIONAL_INDEMNITY]) && [greatAmericanBusinessInsuranceClassServiceGraphicArtistDesignKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT own, host or run and website that:',
          list: [{
            text: 'Contains any pornographic materials',
            showDot: true
          }, {
            text: 'Contains User Generated Content',
            showDot: true
          }, {
            text: 'Is a social networking website',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateServices3 = function generateServices3(list, config) {
    var _config$covers8;

    if (!!(config !== null && config !== void 0 && (_config$covers8 = config.covers) !== null && _config$covers8 !== void 0 && _config$covers8[PROFESSIONAL_INDEMNITY]) && [greatAmericanBusinessInsuranceClassServiceAdvertisingAgenciesKey, hiscoxClassServiceBrandConsultantKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT provide any of the following services:',
          list: [{
            text: 'Legal advice',
            showDot: true
          }, {
            text: 'Lobbying and/or political advice',
            showDot: true
          }, {
            text: 'Medical advice',
            showDot: true
          }, {
            text: 'Sales representative',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateServices4 = function generateServices4(list, config) {
    var _config$covers9;

    if (!!(config !== null && config !== void 0 && (_config$covers9 = config.covers) !== null && _config$covers9 !== void 0 && _config$covers9[PROFESSIONAL_INDEMNITY]) && [hiscoxClassServiceRecruitingEmploymentPlacementsKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT provide any of the following services:',
          list: [{
            text: 'Childcare or nanny recruitment or placements',
            showDot: true
          }, {
            text: 'Act as a Professional Employer Organization (PEO)',
            showDot: true
          }, {
            text: 'Lease employees or provide employees to other organizations',
            showDot: true
          }, {
            text: 'Medical personnel recruitment or placements',
            showDot: true
          }, {
            text: 'Staffing services',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateServices5 = function generateServices5(list, config) {
    var _config$covers10;

    if (!!(config !== null && config !== void 0 && (_config$covers10 = config.covers) !== null && _config$covers10 !== void 0 && _config$covers10[PROFESSIONAL_INDEMNITY]) && [hiscoxClassServiceSoftwareDevelopmentsKey, hiscoxClassServiceITConsultingKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT conduct any of the following:',
          list: [{
            text: "Manage your client's network/ infrastructure on their behalf"
          }, {
            text: 'Ongoing remote monitoring or access to client systems'
          }, {
            text: 'Create, support, or work on software that executes securities transactions, makes medical diagnoses, or is involved in manufacturing or process control'
          }, {
            text: 'Domain Name Registration (DNS)'
          }, {
            text: 'Hardware design or manufacturing (Does not apply to Value Added Resellers of third-party hardware.)'
          }, {
            text: 'Internet content aggregator or web portal'
          }, {
            text: 'Internet or on-line publisher of content'
          }, {
            text: 'Own, host, or run any website that contains pornographic material.'
          }, {
            text: 'Own or manage a social networking, user generated content, or auction website. (Does not apply to hosting services for third-party sites)'
          }, {
            text: 'Operate as a Voice Over IP (VOIP) Service Provider (Does not apply to use of a third-party VOIP service for conducting your own business)'
          }, {
            text: 'Payment processing'
          }]
        }]
      });
    }
  };

  var generateServices6 = function generateServices6(list, config) {
    var _config$covers11, _config$covers12;

    if (!!(config !== null && config !== void 0 && (_config$covers11 = config.covers) !== null && _config$covers11 !== void 0 && _config$covers11[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers12 = config.covers) !== null && _config$covers12 !== void 0 && _config$covers12[BUSINESS_OWNERS_POLICY_COVER])) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT supply, manufacture, or distribute any tangible goods or products.'
        }]
      });
    }
  };

  var generateServices7 = function generateServices7(list, config) {
    var _config$covers13, _config$covers14;

    if ((!!(config !== null && config !== void 0 && (_config$covers13 = config.covers) !== null && _config$covers13 !== void 0 && _config$covers13[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers14 = config.covers) !== null && _config$covers14 !== void 0 && _config$covers14[BUSINESS_OWNERS_POLICY_COVER])) && [hiscoxClassServiceEducationConsultingKey, greatAmericanBusinessInsuranceClassServiceConsultantManagementRiskManagementKey, greatAmericanBusinessInsuranceClassServiceConsultantGeneralKey, greatAmericanBusinessInsuranceClassServiceGraphicArtistDesignKey, greatAmericanBusinessInsuranceClassServiceAdvertisingAgenciesKey, hiscoxClassServiceBrandConsultantKey, hiscoxClassServiceRecruitingEmploymentPlacementsKey, hiscoxClassServiceSoftwareDevelopmentsKey, hiscoxClassServiceITConsultingKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT perform any design, construction, installation removal, or physical repair of any property or tangible good.'
        }]
      });
    }
  };

  var generateServices8 = function generateServices8(list, config) {
    var _config$covers15, _config$covers16;

    if ((!!(config !== null && config !== void 0 && (_config$covers15 = config.covers) !== null && _config$covers15 !== void 0 && _config$covers15[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers16 = config.covers) !== null && _config$covers16 !== void 0 && _config$covers16[BUSINESS_OWNERS_POLICY_COVER])) && [hiscoxClassServiceSoftwareDevelopmentsKey, hiscoxClassServiceITConsultingKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT conduct any of the following:',
          list: [{
            text: 'Hardware design or manufacturing (Does not apply to Value Added Resellers of third-party hardware.)'
          }, {
            text: 'Installation or service technician services (this does not include information technology or electronic devices)'
          }, {
            text: 'Repair or mechanic services (this does not include information technology or electronic devices)'
          }]
        }]
      });
    }
  };

  var generateServices9 = function generateServices9(list, config) {
    var _config$covers17, _config$covers18;

    if ((!!(config !== null && config !== void 0 && (_config$covers17 = config.covers) !== null && _config$covers17 !== void 0 && _config$covers17[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers18 = config.covers) !== null && _config$covers18 !== void 0 && _config$covers18[BUSINESS_OWNERS_POLICY_COVER])) && [greatAmericanBusinessInsuranceClassServiceAdvertisingAgenciesKey, hiscoxClassServiceBrandConsultantKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT provide any of the following services:',
          list: [{
            text: 'Lobbying and/or political advice',
            showDot: true
          }, {
            text: 'Medical advice',
            showDot: true
          }, {
            text: 'Sales representative or retail',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateTypeOfBusiness1 = function generateTypeOfBusiness1(list, config) {
    var _config$covers19, _config$covers20, _config$covers21;

    if ((!!(config !== null && config !== void 0 && (_config$covers19 = config.covers) !== null && _config$covers19 !== void 0 && _config$covers19[PROFESSIONAL_INDEMNITY]) || !!(config !== null && config !== void 0 && (_config$covers20 = config.covers) !== null && _config$covers20 !== void 0 && _config$covers20[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers21 = config.covers) !== null && _config$covers21 !== void 0 && _config$covers21[BUSINESS_OWNERS_POLICY_COVER])) && [hiscoxClassServiceEducationConsultingKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Type of Business',
        list: [{
          hideDot: true,
          text: 'Your business IS NOT any of the following',
          list: [{
            text: 'Preschool',
            showDot: true
          }, {
            text: 'Public/private/charter school',
            showDot: true
          }, {
            text: 'College or university',
            showDot: true
          }, {
            text: 'Day care or eldercare facility',
            showDot: true
          }, {
            text: 'Technical or Vocational School',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateProvidedServices1 = function generateProvidedServices1(list, config) {
    var _config$covers22;

    var addItem = false;

    if (config !== null && config !== void 0 && (_config$covers22 = config.covers) !== null && _config$covers22 !== void 0 && _config$covers22[PROFESSIONAL_INDEMNITY] && [hiscoxClassServiceEducationConsultingKey, greatAmericanBusinessInsuranceClassServiceConsultantManagementRiskManagementKey, greatAmericanBusinessInsuranceClassServiceConsultantGeneralKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      addItem = true;
    }

    if (addItem) {
      list.push({
        text: 'Provided Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT provide any of the following services:',
          list: [{
            text: 'Aerospace consulting or advice',
            showDot: true
          }, {
            text: 'Actuarial advice',
            showDot: true
          }, {
            text: 'Architecture or engineering advice',
            showDot: true
          }, {
            text: 'Construction management or advice',
            showDot: true
          }, {
            text: 'Credit counseling',
            showDot: true
          }, {
            text: 'Environmental consulting or advice',
            showDot: true
          }, {
            text: 'Financing or financial auditing',
            showDot: true
          }, {
            text: 'General contracting',
            showDot: true
          }, {
            text: 'Investment or tax advice',
            showDot: true
          }, {
            text: 'Insurance placement or advice',
            showDot: true
          }, {
            text: 'Land acquisition',
            showDot: true
          }, {
            text: 'Law enforcement training',
            showDot: true
          }, {
            text: 'Legal advice',
            showDot: true
          }, {
            text: 'Lobbying and/or political advice',
            showDot: true
          }, {
            text: 'Medical advice',
            showDot: true
          }, {
            text: 'Mergers and acquisitions or business valuations',
            showDot: true
          }, {
            text: 'Mining consulting or advice',
            showDot: true
          }, {
            text: 'Oil, gas, or petroleum consulting or advice',
            showDot: true
          }, {
            text: 'Safety consulting or advice',
            showDot: true
          }, {
            text: 'Sales representative',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateProvidedServices2 = function generateProvidedServices2(list, config) {
    var _config$covers23, _config$covers24;

    if ((!!(config !== null && config !== void 0 && (_config$covers23 = config.covers) !== null && _config$covers23 !== void 0 && _config$covers23[PUBLIC_LIABILITY]) || !!(config !== null && config !== void 0 && (_config$covers24 = config.covers) !== null && _config$covers24 !== void 0 && _config$covers24[BUSINESS_OWNERS_POLICY_COVER])) && [greatAmericanBusinessInsuranceClassServiceConsultantManagementRiskManagementKey, greatAmericanBusinessInsuranceClassServiceConsultantGeneralKey, hiscoxClassServiceEducationConsultingKey].includes(config === null || config === void 0 ? void 0 : config.businessActivity)) {
      list.push({
        text: 'Provided Services',
        list: [{
          hideDot: true,
          text: 'Your business DOES NOT provide any of the following services:',
          list: [{
            text: 'Aerospace consulting or advice',
            showDot: true
          }, {
            text: 'Architecture or engineering advice',
            showDot: true
          }, {
            text: 'Construction management or advice',
            showDot: true
          }, {
            text: 'Environmental consulting or advice',
            showDot: true
          }, {
            text: 'General contracting',
            showDot: true
          }, {
            text: 'Land acquisition',
            showDot: true
          }, {
            text: 'Law enforcement training',
            showDot: true
          }, {
            text: 'Medical advice',
            showDot: true
          }, {
            text: 'Mining consulting or advice',
            showDot: true
          }, {
            text: 'Oil, gas, or petroleum consulting or advice',
            showDot: true
          }, {
            text: 'Safety consulting or advice',
            showDot: true
          }, {
            text: 'Sales representative',
            showDot: true
          }]
        }]
      });
    }
  };

  var generateTraining1 = function generateTraining1(list, config) {}; // Generate Declaration Question


  var generateHiscoxPIDeclarationQuestionInfo = function generateHiscoxPIDeclarationQuestionInfo(data) {
    var businessActivity = data.businessActivity;
    var questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[HISCOX_PI_DECLARATION]);
    var specList = [];
    generatePhysicalServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateTypeOfBusiness1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateProvidedServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateServices2(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateServices3(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateServices4(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    generateServices5(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PROFESSIONAL_INDEMNITY, 1)
    });
    questionInfo.spec = specList;
    return questionInfo;
  };

  var generateHiscoxPLDeclarationQuestionInfo = function generateHiscoxPLDeclarationQuestionInfo(data) {
    var businessActivity = data.businessActivity;
    var questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[HISCOX_PL_DECLARATION]);
    var specList = [];
    generateProvidedServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generatePhysicalServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generateServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generateTypeOfBusiness1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generateServices3(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generateProvidedServices2(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generateServices8(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    generateServices9(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, PUBLIC_LIABILITY, 1)
    });
    questionInfo.spec = specList;
    return questionInfo;
  };

  var generateHiscoxCyberDeclarationQuestionInfo = function generateHiscoxCyberDeclarationQuestionInfo(data) {
    var businessActivity = data.businessActivity;
    var questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[HISCOX_CYBER_DECLARATION]);
    var specList = [];
    generateTraining1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, CYBER_LIABILITY_COVER, 1)
    });
    questionInfo.spec = specList;
    return questionInfo;
  };

  var generateHiscoxBOPDeclarationQuestionInfo = function generateHiscoxBOPDeclarationQuestionInfo(data) {
    var businessActivity = data.businessActivity;
    var questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[HISCOX_BOP_DECLARATION]);
    var specList = [];
    generateProvidedServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generatePhysicalServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generateServices1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generateTypeOfBusiness1(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generateServices3(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generateProvidedServices2(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generateServices8(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    generateServices9(specList, {
      businessActivity: businessActivity,
      covers: _defineProperty({}, BUSINESS_OWNERS_POLICY_COVER, 1)
    });
    questionInfo.spec = specList;
    return questionInfo;
  };

  var generateHiscoxUSDeclaration = function generateHiscoxUSDeclaration(data, covers) {
    var businessActivity = data.businessActivity;
    var questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[HISCOX_DECLARATION]);
    var specList = [];
    generatePhysicalServices1(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateServices1(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateTypeOfBusiness1(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateProvidedServices1(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateServices2(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateServices3(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateServices4(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateServices5(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateProvidedServices2(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateServices8(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    generateTraining1(specList, {
      businessActivity: businessActivity,
      covers: covers
    });
    questionInfo.spec = specList;
    return questionInfo;
  };

  return {
    generateHiscoxPIDeclarationQuestionInfo: generateHiscoxPIDeclarationQuestionInfo,
    generateHiscoxPLDeclarationQuestionInfo: generateHiscoxPLDeclarationQuestionInfo,
    generateHiscoxCyberDeclarationQuestionInfo: generateHiscoxCyberDeclarationQuestionInfo,
    generateHiscoxBOPDeclarationQuestionInfo: generateHiscoxBOPDeclarationQuestionInfo,
    generateHiscoxUSDeclaration: generateHiscoxUSDeclaration
  };
};